// @flow
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

type Props = {
  value: string;
};

const CopyButton = (props: Props) => {
  const { value } = props;

  const [copied, setCopied] = useState(false);

  const onCopyHandler = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <>
      <CopyToClipboard text={value} onCopy={onCopyHandler}>
        <span className="copyButton">
          <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8749 11.7C11.6129 11.7 11.3999 11.4983 11.3999 11.25V2.25005C11.3999 2.00185 11.6129 1.80005 11.8749 1.80005C12.1369 1.80005 12.3499 2.00185 12.3499 2.25005V11.25C12.3499 11.3696 12.3002 11.4842 12.2111 11.5686C12.1221 11.6529 12.0011 11.7 11.8749 11.7L11.8749 11.7Z" fill="#1776E3" />
            <path d="M11.8748 11.7H4.2748C4.01281 11.7 3.7998 11.4983 3.7998 11.25C3.7998 11.0018 4.01281 10.8 4.2748 10.8H11.8748C12.1368 10.8 12.3498 11.0018 12.3498 11.25C12.3498 11.4983 12.1368 11.7 11.8748 11.7Z" fill="#1776E3" />
            <path d="M4.2748 11.7C4.01281 11.7 3.7998 11.4983 3.7998 11.25V2.25005C3.7998 2.00185 4.01281 1.80005 4.2748 1.80005C4.5368 1.80005 4.7498 2.00185 4.7498 2.25005V11.25C4.7498 11.3696 4.70008 11.4842 4.61102 11.5686C4.52195 11.6529 4.40097 11.7 4.27481 11.7L4.2748 11.7Z" fill="#1776E3" />
            <path d="M11.8748 2.70005H4.2748C4.01281 2.70005 3.7998 2.49825 3.7998 2.25005C3.7998 2.00185 4.01281 1.80005 4.2748 1.80005H11.8748C12.1368 1.80005 12.3498 2.00185 12.3498 2.25005C12.3498 2.49825 12.1368 2.70005 11.8748 2.70005Z" fill="#1776E3" />
            <path d="M0.475 9.9C0.213009 9.9 0 9.6982 0 9.45V0.45C0 0.201798 0.213009 0 0.475 0C0.736991 0 0.95 0.201798 0.95 0.45V9.45C0.95 9.56953 0.900273 9.68414 0.81121 9.76851C0.722148 9.85288 0.601165 9.9 0.475006 9.9L0.475 9.9Z" fill="#1776E3" />
            <path d="M8.075 0.9H0.475C0.213009 0.9 0 0.698202 0 0.45C0 0.201798 0.213009 0 0.475 0H8.075C8.33699 0 8.55 0.201798 8.55 0.45C8.55 0.698202 8.33699 0.9 8.075 0.9Z" fill="#1776E3" />
            <path d="M2.375 9.9H0.475C0.213009 9.9 0 9.6982 0 9.45C0 9.2018 0.213009 9 0.475 9H2.375C2.63699 9 2.85 9.2018 2.85 9.45C2.85 9.6982 2.63699 9.9 2.375 9.9Z" fill="#1776E3" />
          </svg>
        </span>
      </CopyToClipboard>
      {copied ? <div className="copyButton-message arrow-top show">copied</div> : null}
    </>
  );
};

export default CopyButton;
